module.exports = __webpack_public_path__ + "media/gun_4.870a6324.webm";